export class PhoneNumberAlreadyExistsError extends Error {
  public constructor() {
    super()

    this.message = 'errors.phoneNumberAlreadyExists'
  }
}
